/**
 * FormTypeViewEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { FormTypeVersionEntity } from "../FormTypeVersionEntity";
import { FormTypeViewEntity } from "../FormTypeViewEntity";
declare global {
    interface EntityTypeMap {
        FormTypeView: FormTypeViewEntity;
    }
}
export abstract class FormTypeViewGeneratedEntity extends BaseEntity {
    public abstract formTypeViewId: string;
    public abstract templateId: string | null;
    public abstract type: string;
    public abstract name: string;
    public abstract engineVersion: number;
    public abstract engineMinVersion: number;
    public abstract data: string | null;
    public abstract version: FormTypeVersionEntity;
}
